import { createContext, useContext } from 'react';
import noop from 'utils/noop';

type AdAccountIdType = {
  adAccountIds: string[];
  unselectedAdAccountIds: string[];
  allAdAccountIds: string[];
  addAdAccounts: (adAccount: string) => void;
  removeAdAccounts: (adAccount: string) => void;
  clearAllAdAccounts: () => void;
  selectAllAdAccounts: () => void;
  isLoading: boolean;
};

export const AdAccountContext = createContext<AdAccountIdType>({
  adAccountIds: [],
  allAdAccountIds: [],
  unselectedAdAccountIds: [],
  clearAllAdAccounts: noop,
  selectAllAdAccounts: noop,
  addAdAccounts: noop,
  removeAdAccounts: noop,
  isLoading: false,
});

export const useAdAccountContext = () => useContext(AdAccountContext);
